/**
 * Absolute URL zu einem Skript unter /api/ (berücksichtigt Webpack publicPath).
 * @param {string} relativePath z. B. "api/auth.php"
 */
export function buildApiUrl(relativePath) {
  const rel = String(relativePath || '').replace(/^\//, '');
  const pub =
    typeof __PUBLIC_PATH__ !== 'undefined' ? String(__PUBLIC_PATH__) : '/';
  const root = pub.endsWith('/') ? pub : `${pub}/`;
  const base = new URL(root, window.location.origin).href;
  return new URL(rel, base).href;
}
